import { Icon } from '@chakra-ui/react';

export default function WarningTriangleFilled() {
  return (
    <Icon width="20px" height="18px">
      <svg viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.8742 1.57348L19.1746 16.5144C19.5449 17.1809 19.063 18 18.3005 18H10H1.69951C0.93703 18 0.455062 17.1809 0.825357 16.5144L9.12584 1.57348C9.50685 0.887674 10.4932 0.887674 10.8742 1.57348Z"
          fill="#E64643"
        />
        <rect x="9" y="5" width="2" height="7" rx="1" fill="white" />
        <rect x="9" y="13" width="2" height="2" rx="1" fill="white" />
      </svg>
    </Icon>
  );
}
